/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ExternalApiKeyV1Dto = {
  /**
   * The unique identifier of the entity.
   */
  readonly id: string;
  /**
   * The date when the entity was created.
   */
  readonly createdAt: string;
  /**
   * The date when the entity was modified.
   */
  readonly modifiedAt: string;
  /**
   * The External API Key
   */
  apiKey: string;
  /**
   * External API Key validation flag
   */
  valid: boolean;
  /**
   * External API Key type
   */
  type: ExternalApiKeyV1Dto.type;
};
export namespace ExternalApiKeyV1Dto {
  /**
   * External API Key type
   */
  export enum type {
    BREVO = 'Brevo',
    YOU_SIGN = 'YouSign',
  }
}
